import React, {useState} from 'react';

import { useGetUserActivityLogsQuery } from '@/features/userActivityLogs/userActivityLogsApiSlice';
import { useGetUserPicQuery } from "@/features/users/usersApiSlice"

import { userProfileIcon2 } from "@/assets/img/imgAssets"
import EtCelebrateEffortIconSVGComp from "@/assets/img/icons/svgComp/EtCelebrateEffortIcon1SVGComp";

// 10 Apr 2025
import { getTimeSince } from "@/utils/EtGetTimeSince"

// 10 Apr 2025
import EtWabActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabActionIcon1SVGComp"
import EtCelebratePointsIcon1SVGComp from "@/assets/img/icons/svgComp/EtCelebratePointsIcon1SVGComp"

// 15 Apr 2025
import EtWabReflectionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabReflectionIcon1SVGComp"
import EtWabConversationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabConversationIcon1SVGComp" 
import EtWabCreationIcon1SVGComp  from "@/assets/img/icons/svgComp/EtWabCreationIcon1SVGComp" 
import EtWabGratitudeIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabGratitudeIcon1SVGComp"  
import EtWabContributionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabContributionIcon1SVGComp"
import EtWabImpactIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabImpactIcon1SVGComp"
import EtWabWinIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabWinIcon1SVGComp"
import EtWabIntentionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabIntentionIcon1SVGComp"
import EtWabChallengeIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabChallengeIcon1SVGComp"

// 16 Apr 2025
import EtCelebrateArenasIcon1SVGComp from "@/assets/img/icons/svgComp/EtCelebrateArenasIcon1SVGComp"

// 11 Apr 2025
import { POINTS_CONFIG } from '@/utils/pointsConfig';
import moment from 'moment';


const EtTrinityWebCelebrateExcellenceLog = ({username, userId, userOrgId}) => {
  // Author - Atul Pandey
  // First Created - 09 Apr 2025
  // Purpose to act as the home page for Trinity Landing - Celebrate - Excellence Log
  // Updated - 11 Apr 2025 - added POINTS_CONFIG and computePoints function
  // Updated - 11 Apr 2025 - added tabs - 'summary' or 'details'
  // Updated - 11 Apr 2025 - added periods - 'today' | 'week' | 'month' | 'quarter' | 'year'
  // Updated - 14 Apr 2025 - added helper function to calculate excellence points
  // Updated - 15 Apr 2025 - added summaryMenuItems and the helper function to extract matching category image
  // Updated - 15 Apr 2025 - added activityCategoryItems and the helper function to extract matching category image
  // Updated - 16 Apr 2025 - JSX display refinements - Arenas
  // Updated - 16 Apr 2025 - JSX display refinements - Changed the summaryItemsMenu indexing based on filtered log counts
  // Updated - 26 Apr 2025 - refined the calculateExcellencePointsForCategory to calculate total points for all categories and not just actions.
  // Updated - 07 Dec 2025 - time chip date fences refined - to align with latest comps such as Reflection Center, Morning Habits

  
  // 1a - State Variables
  const [activeTab, setActiveTab] = useState('details'); // 11 Apr 2025 
  const [activePeriod, setActivePeriod] = useState('today'); // 11 Apr 2025

  
  // 1b - Activity Category Items - 15 Apr 2025
  const activityCategoryIcons = {
    Action: EtWabActionIcon1SVGComp,
    Reflection: EtWabReflectionIcon1SVGComp,
    Conversation: EtWabConversationIcon1SVGComp,
    Creation: EtWabCreationIcon1SVGComp,
    Contribution: EtWabContributionIcon1SVGComp,
    Impact: EtWabImpactIcon1SVGComp,
    Win: EtWabWinIcon1SVGComp,
    Challenge: EtWabChallengeIcon1SVGComp,
    Intention: EtWabIntentionIcon1SVGComp,
    Gratitude: EtWabGratitudeIcon1SVGComp,
  };
  
  
  // 1c - Summary Menu Items: 15 Apr 2025
  const summaryMenuItems = [
      { label: "Action", icon: EtWabActionIcon1SVGComp,},
      { label: "Reflection", icon: EtWabReflectionIcon1SVGComp,},
      { label: "Conversation", icon: EtWabConversationIcon1SVGComp,},
      { label: "Creation", icon: EtWabCreationIcon1SVGComp,},
      { label: "Contribution", icon: EtWabContributionIcon1SVGComp,},
      { label: "Impact", icon: EtWabImpactIcon1SVGComp,},
      { label: "Win", icon: EtWabWinIcon1SVGComp,},
      { label: "Challenge", icon: EtWabChallengeIcon1SVGComp,},
      { label: "Intention", icon: EtWabIntentionIcon1SVGComp,},
      { label: "Gratitude", icon: EtWabGratitudeIcon1SVGComp,},
      
  ]

  // 1d - Extract matching category image
  const getCategoryIcon = (category) => {
    const match = summaryMenuItems.find(item => item.label.toLowerCase() === category.toLowerCase());
    return match?.icon || EtWabActionIcon1SVGComp; // Fallback to Action icon
  };
  
  
  // 2a - Get Data from the RTK queries
  const {
    data: activityLogsData,
    isLoading,
    isError,
    error,
  } = useGetUserActivityLogsQuery(userId);

  // 2b - Select Time period - Updated - 07 Dec 2025

  // 07 Dec 2025
  // --- Time Range Definitions (Aligned with Reflection Center) ---
  const now = moment();
  const startOfToday = moment().startOf("day");
  const endOfToday = moment().endOf("day");

  const startOfWeek = moment().isoWeekday(1).startOf("day");
  const endOfWeek = endOfToday;

  const startOfMonth = moment().startOf("month");
  const endOfMonth = moment().isSame(now, "month")
    ? endOfToday
    : moment().endOf("month");

  const startOfQuarter = moment().startOf("quarter");
  const endOfQuarter = moment().isSame(now, "quarter")
    ? endOfToday
    : moment().endOf("quarter");

  const startOfYear = moment().startOf("year");
  const endOfYear = moment().isSame(now, "year")
    ? endOfToday
    : moment().endOf("year");

  // --- Time-Based Filtering Helper ---
  const filterByTime = (logs, start, end) =>
    logs.filter((log) => {
      const d = moment(log.createdAt);
      return d.isBetween(start, end, null, "[]");
    });

  // Prior to 07 Dec 2025 code
  // const isInSelectedPeriod = (dateString) => {
  //   const now = moment();
  //   const logDate = moment(dateString);
  
  //   switch (activePeriod) {
  //     case 'today':
  //       return logDate.isSame(now, 'day');
  //     case 'week':
  //       return logDate.isSame(now, 'week');
  //     case 'month':
  //       return logDate.isSame(now, 'month');
  //     case 'quarter':
  //       return logDate.isSame(now, 'quarter');
  //     case 'year':
  //       return logDate.isSame(now, 'year');
  //     default:
  //       return true;
  //   }
  // };

  // 3 - Define the logs
  // const logs = activityLogsData?.ids?.map(id => activityLogsData.entities[id]) || [];
  const allLogs = activityLogsData?.ids?.map(id => activityLogsData.entities[id]) || [];
  
  // 07 Dec 2025
  // --- Generate time buckets ---
  const logsToday = filterByTime(allLogs, startOfToday, endOfToday);
  const logsThisWeek = filterByTime(allLogs, startOfWeek, endOfWeek);
  const logsThisMonth = filterByTime(allLogs, startOfMonth, endOfMonth);
  const logsThisQuarter = filterByTime(allLogs, startOfQuarter, endOfQuarter);
  const logsThisYear = filterByTime(allLogs, startOfYear, endOfYear);
  

  // --- Determine displayed logs ---
  let logs = [];

  switch (activePeriod) {
    case "week":
      logs = logsThisWeek;
      break;
    case "month":
      logs = logsThisMonth;
      break;
    case "quarter":
      logs = logsThisQuarter;
      break;
    case "year":
      logs = logsThisYear;
      break;
    case "all":
      logs = allLogs;
      break;
    case "today":
    default:
      logs = logsToday;
      break;
  }

  
  // const logs = allLogs.filter(log => isInSelectedPeriod(log.createdAt));
  // console.log('logs', logs)

  // 4 - Compute log points
  const computePoints = (log) => {
    const { activityCategory, activityType } = log;
    const details = JSON.parse(log.encryptedDetails || '{}');
    const categoryConfig = POINTS_CONFIG[activityCategory];
    if (categoryConfig && typeof categoryConfig[activityType] === 'function') {
      return categoryConfig[activityType](details);
    }
    return 0;
  };

  // 5 - Get Action Log badge colors
  const getBadgeClass = (badge) => {
    switch (badge) {
      case "accomplished!":
        return "bg-lime-600 text-white";
      case "moved!":
        return "bg-lime-400";
      case "persisted!":
        return "bg-yellow-300";
      case "created!":
        return "bg-yellow-200";
      default:
        return "bg-gray-200"; // Default case if no badge matches
    }
  };

  // 6 - Helper function to calculate excellence points - 14 Apr 2025, updated 15 Apr 2025, updated 26 Apr 2025

  // 26 Apr 2025

  const calculateExcellencePointsForCategory = (logsForCategory) => {
    const category = logsForCategory[0]?.activityCategory;
    const categoryConfig = POINTS_CONFIG[category];
  
    if (category === 'Action') {
      // Special handling for Actions
      const pointsMap = new Map();
  
      logsForCategory.forEach(log => {
        const key = log.associatedEntityId;
        const details = JSON.parse(log.encryptedDetails || '{}');
        const existing = pointsMap.get(key);
  
        if (log.activityType === 'accomplished') {
          pointsMap.set(key, 100);
        } else if (['moved', 'persisted'].includes(log.activityType) && !existing) {
          pointsMap.set(key, details.updatedProgress ?? 0);
        } else if (log.activityType === 'created' && !existing) {
          pointsMap.set(key, details.progress ?? 0);
        }
      });
  
      return Array.from(pointsMap.values()).reduce((a, b) => a + b, 0);
    } else {
      // For other categories, sum points normally
      return logsForCategory.reduce((total, log) => {
        const details = JSON.parse(log.encryptedDetails || '{}');
        if (log.activityType === 'created' && categoryConfig?.created) {
          return total + categoryConfig.created(details);
        }
        return total;
      }, 0);
    }
  };


  // const calculateExcellencePointsForCategory = (logsForCategory) => {
  //   const category = logsForCategory[0]?.activityCategory;
  //   const categoryConfig = POINTS_CONFIG[category];
  //   const pointsMap = new Map();
  
  //   logsForCategory.forEach(log => {
  //     const key = log.associatedEntityId;
  //     const details = JSON.parse(log.encryptedDetails || '{}');
  
  //     if (category === 'Action') {
  //       const existing = pointsMap.get(key);
  
  //       if (log.activityType === 'accomplished') {
  //         pointsMap.set(key, 100);
  //       } else if (['moved', 'persisted'].includes(log.activityType) && !existing) {
  //         pointsMap.set(key, details.updatedProgress ?? 0);
  //       }
  //     } else if (log.activityType === 'created' && categoryConfig?.created) {
  //       pointsMap.set(key, categoryConfig.created(details));
  //     }
  //   });
  
  //   return Array.from(pointsMap.values()).reduce((a, b) => a + b, 0);
  // };
  

//   const calculateExcellencePointsForCategory = (logsForCategory) => {
//     const uniqueActionLogs = new Map();
  
//     logsForCategory
//       .filter(log => log.activityCategory === 'Action')
//       .forEach(log => {
//         const details = JSON.parse(log.encryptedDetails || '{}');
//         const key = log.associatedEntityId;
//         const existing = uniqueActionLogs.get(key);
  
//         if (log.activityType === 'accomplished') {
//           uniqueActionLogs.set(key, 100); // max score
//         } else if (
//           ['moved', 'persisted'].includes(log.activityType) &&
//           !existing
//         ) {
//           uniqueActionLogs.set(key, details.updatedProgress ?? 0);
//         }
//       });
  
//     const totalPoints = Array.from(uniqueActionLogs.values()).reduce((a, b) => a + b, 0);
//     return totalPoints;
//   };
  

  return (
    <div className='font-poppins'>
        <div className='m-1 p-1 border-b-4 border-orange-600'>
            <div className='flex justify-start items-center'>
                <div className='flex justify-center items-center w-10 h-10 rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-md'>
                    <EtCelebrateEffortIconSVGComp className="h-7 w-7 text-white" />
                </div>
                <div className='mx-1 px-1 pb-2'>
                    {/* <p className="text-md sm:text-xl font-semibold mb-1">Excellence Log – The Effort</p>
                    <p className="text-[10px] sm:text-[13px] text-gray-500">Logs of your activities, categorized by Trinity Areas.</p> */}
                    <p className="text-md sm:text-xl font-semibold mb-1">Excellence Log – The Effort</p>
                    <p className="text-[10px] sm:text-[13px] text-gray-500">Let every effort you made count!</p>
                </div>
            </div>
        </div>
        {/* Tabs */}
        <div className="flex justify-start space-x-4 border-b border-orange-300 mb-4 mt-2">
          <button
            className={`text-sm font-semibold px-3 py-1 rounded-t ${activeTab === 'summary' ? 'bg-orange-200 text-orange-800' : 'text-gray-500'}`}
            onClick={() => setActiveTab('summary')}
          >
            Summary
          </button>
          <button
            className={`text-sm font-semibold px-3 py-1 rounded-t ${activeTab === 'details' ? 'bg-orange-200 text-orange-800' : 'text-gray-500'}`}
            onClick={() => setActiveTab('details')}
          >
            Details
          </button>
        </div>

        {/* Display the logs here */}
        {(activeTab === 'summary' || activeTab === 'details') && (
          <div className="mt-2">
            {/* Sub-tabs for time filters */}
            <div className="flex flex-wrap gap-1 xl:gap-2 mb-3 text-[9px] xl:text-xs font-semibold">
              {['today', 'week', 'month', 'quarter', 'year'].map(period => (
                <button
                  key={period}
                  className={`px-2 py-1 rounded-full border ${
                    activePeriod === period
                      ? 'bg-orange-600 text-white'
                      : 'bg-gray-100 text-gray-600'
                  }`}
                  onClick={() => setActivePeriod(period)}
                >
                  {period === 'today' && 'Today'}
                  {period === 'week' && 'This Week'}
                  {period === 'month' && 'This Month'}
                  {period === 'quarter' && 'This Qtr'}
                  {period === 'year' && 'This Year'}
                </button>
              ))}
            </div>

            {activeTab === 'details' && (
                <div className="space-y-1 mt-2 overflow-y-auto max-h-[70vh] rounded bg-gray-200 m-1 p-1 shadow-lg shadow-black">
                    {isLoading && <p className="text-sm text-gray-500">Loading logs...</p>}
                    {isError && <p className="text-sm text-red-500">Error loading logs: {error?.message}</p>}
                    {logs.length === 0 && !isLoading && (
                        <p className="text-sm text-gray-800 italic m-1 p-1">No activities logged yet.</p>
                    )}
                    {logs
                    // ?.filter(log => isInSelectedPeriod(log.createdAt)) // 07 Dec 2025 - commented as this is not needed any more. We are doing logs filtering based on time chip upfront.
                    ?.map((log, logIndex) => {
                        let details = {};
                        try {
                            details = JSON.parse(log.encryptedDetails);
                        } catch (err) {
                            console.warn(`Failed to parse encryptedDetails for log ${log.id}`, err);
                        }

                        const isAction = log.activityCategory === 'Action';
                        const { activityType } = log;
                        
                        return (
                            <div key={log.id+logIndex} className="p-3 mb-1 bg-white rounded shadow border border-orange-200 font-poppins">
                                <div className='flex justify-between items-center'>
                                    <div className='flex justify-start items-center'>
                                        <div>
                                            <p className='font-bold text-gray-600 xl:mx-1 xl:px-1'>{logIndex+1}.</p>
                                        </div>
                                        <div className='flex justify-center items-center w-8 h-8 rounded-full'>
                                            {/* <EtWabActionIcon1SVGComp className='h-6 w-6 text-orange-600'/> */}
                                            {(() => {
                                                const IconComponent = activityCategoryIcons[log.activityCategory] || EtWabActionIcon1SVGComp;
                                                return <IconComponent className="h-6 w-6 text-orange-600" />;
                                            })()}
                                        </div>
                                        <div className='xl:mx-1 xl:px-1'>
                                            <p className="text-[11px] xl:text-xs font-semibold capitalize text-orange-700">
                                                {log.activityCategory}
                                            </p>
                                        </div>
                                    </div>
                                    {/* Badge */}
                                    <div className="text-center mx-1 px-1">
                                        <div className={`text-[10px] px-2 py-[1px] capitalize rounded-full inline-block ${getBadgeClass(`${activityType.toLowerCase()}!`)}`}>
                                        {activityType}
                                        </div>
                                    </div>

                                    <div className='flex justify-start items-center'>
                                        <div>
                                            <p className='text-[9px] mx-[2px] px-[2px] xl:mx-1 xl:px-1 text-gray-600'>Excellence Points:</p>
                                        </div>
                                        <div className='flex justify-center items-center rounded-full w-6 h-6 bg-lime-500 shadow-lg shadow-black'>
                                            {/* <p className='text-[10px] font-bold'>{earnedPoints}</p> */}
                                            <p className='text-[10px] font-bold'>{computePoints(log)}</p>
                                        </div>
                                    </div>
                                </div>
                            {isAction && activityType === 'created' && (
                                <div className='border-t my-1'>
                                {details?.actionName && (
                                    <p className="text-xs text-gray-800 mt-1">
                                    <span className="font-medium">Created:</span> {details.actionName}
                                    </p>
                                )}
                                {details?.progress !== undefined && (
                                    <p className="text-xs text-gray-600 my-1">
                                    <span className="font-medium">Initial Progress:</span> {details.progress}%
                                    </p>
                                )}
                                {details?.completeBy && (
                                    <p className="text-xs text-gray-600">
                                    <span className="font-medium mb-1">Complete by:</span>{" "}
                                    {new Date(details.completeBy).toLocaleDateString()}
                                    </p>
                                )}
                                </div>
                            )}

                            {isAction && ['moved', 'accomplished'].includes(activityType)  && (
                                <div className='border-t my-1'>
                                {details?.actionName && (
                                    <p className="text-xs text-gray-800 mt-1">
                                    <span className="font-medium">Progressed:</span> {details.actionName}
                                    </p>
                                )}
                                {details?.previousProgress !== undefined && (
                                    <p className="text-xs text-gray-600 my-1">
                                    <span className="font-medium">From:</span> {details.previousProgress}%{" "}
                                    <span className="font-medium">To:</span> {details.updatedProgress}%
                                    </p>
                                )}
                                </div>
                            )}

                        <div className='border-t my-1'>
                                
                                <div className='flex justify-between items-center'>
                                    <div>
                                        <p className="text-xs text-gray-400 mt-2">
                                            Logged at: {new Date(log.createdAt).toLocaleString()}
                                        </p>
                                    </div>
                                    <div >
                                        <p className="text-[8px] rounded-full px-2 mt-2 py-[1px] bg-lime-200 w-full">
                                            {getTimeSince(new Date(log.createdAt).toLocaleString())}
                                        </p>
                                    </div>
                                </div>
                                
                        </div>          
                            </div>
                        );
                    })}

                </div>
            )}

            {activeTab === 'summary' && (
            <div className="mt-4 space-y-1 overflow-y-auto max-h-[70vh] rounded bg-gray-200 m-1 p-1 shadow-lg shadow-black">
                 {logs.length === 0 && !isLoading && (
                        <p className="text-sm text-gray-800 italic m-1 p-1">No activities logged yet.</p>
                    )}

                
                {/* Summary Overview Card */}
                <div className="bg-white rounded shadow border border-orange-400 p-4 mb-2">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-md xl:text-lg font-bold text-orange-800">Excellence Board</h3>
                    <div className='flex justify-start items-center'>
                        <div>
                            <p className="text-xs text-gray-500 mx-1 px-1">Arenas: </p>
                        </div>
                        <div>
                        <EtCelebrateArenasIcon1SVGComp className='h-6 w-6 text-orange-600' />
                        </div> 
                        <div className='flex justify-center items-center bg-orange-50 border border-orange-600 rounded-full w-6 h-6 mx-1'>
                            <p className='font-bold text-sm mx-1 px-1'>{
                            Object.keys(
                                logs.reduce((acc, log) => {
                                acc[log.activityCategory] = true;
                                return acc;
                                }, {})
                            ).length
                            }</p>
                        </div>
                        
                    </div>
                    
                </div>

                <div className="flex justify-between items-center bg-orange-600 rounded px-3 py-2 shadow">
                    <p className="text-md font-semibold text-white">Total Points:</p>
                    <div className="text-lg font-bold text-white">
                    {logs.reduce((sum, log) => sum + computePoints(log), 0)}
                    </div>
                </div>

                <div className="mt-3 space-y-2">
                    {summaryMenuItems
                    ?.filter(item => logs.some(log => log.activityCategory === item.label))
                    ?.map((item, index) => {
                    const categoryLogs = logs.filter(log => log.activityCategory === item.label);
                    if (categoryLogs.length === 0) return null;

                    return (
                        <div key={item.label} className="grid grid-cols-8 justify-between items-center bg-gray-50 px-3 py-2 rounded border border-gray-200 shadow-sm">
                        
                            <div className="col-span-4 flex items-center space-x-1 xl:space-x-2">
                                <p className="text-sm font-semibold text-gray-700">{`${index + 1}.`}</p>
                                <item.icon className="h-4 w-4 xl:h-6 xl:w-6 text-orange-600" />
                                <p className="text-[11px] xl:text-sm font-semibold text-gray-700">{`${item.label}s`}</p>
                            </div>

                            <div className='col-span-2 flex justify-start items-center'>
                                <p className="text-[10px] text-gray-800 mx-1 px-1">
                                    Total:
                                </p>
                                <div className='flex justify-center items-center rounded-full w-10 bg-yellow-300 shadow-lg shadow-black'>
                                    <p className=" text-[9px] xl:text-[10px] text-gray-800 font-bold py-[1px]">
                                        {categoryLogs.length}
                                    </p>
                                </div>
                                
                            </div>

                            <div className='col-span-2 flex justify-start items-center'>
                                <p className="text-[10px] text-gray-800 xl:mx-1 xl:px-1 px-[2px] mx-[2px]">
                                    Points: 
                                </p>
                                <div className='flex justify-center items-center rounded-full w-12 px-1 bg-lime-400 shadow-lg shadow-black'>
                                    <p className="text-[9px] xl:text-[10px] text-gray-800 font-bold py-[1px]">
                                {calculateExcellencePointsForCategory(categoryLogs)}
                                </p>
                                </div>
                                
                            </div>  
                        </div>
                    );
                    })}
                </div>
                </div>


                {/* Group logs by activityCategory */}
                {Object.entries(
                logs.reduce((acc, log) => {
                    if (!acc[log.activityCategory]) acc[log.activityCategory] = [];
                    acc[log.activityCategory].push(log);
                    return acc;
                }, {})
                ).map(([category, catLogs]) => {
                const typeCounts = catLogs.reduce((counts, log) => {
                    counts[log.activityType] = (counts[log.activityType] || 0) + 1;
                    return counts;
                }, {});
                
                return (
                    <div key={category} className="bg-white rounded shadow border border-orange-300 p-4">
            
                        <div className='grid grid-cols-7 justify-between items-start gap-2'>
                            <div className='col-span-2 flex flex-col justify-center items-center'>
                                <p className="text-xs xl:text-sm font-bold text-orange-700 m-2">{category}s</p>
                                <div className='h-8 w-8 xl:h-12 xl:w-12 flex justify-center items-center rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-lg shadow-black'>
                                    {/* <EtWabActionIcon1SVGComp className='h-10 w-10 text-white'/> */}
                                    {React.createElement(getCategoryIcon(category), { className: 'h-6 w-6 xl:h-10 xl:w-10 text-white' })}
                                </div>
                            </div>

                            <div className='col-span-3 flex flex-col justify-start items-center'>
                                
                                <div className='grid grid-cols-4 justify-start items-center border-b mb-3 pb-3'>
                                    <div className='col-span-3'>
                                        <p className="text-sm xl:text-lg text-gray-600 font-bold mx-1 px-1">Total:</p>
                                    </div>
                                    <div className='col-span-1'>
                                        <div className='flex justify-center items-center h-6 w-6 xl:w-8 xl:h-8 rounded-full bg-lime-400'>
                                            <p className='font-bold text-xs xl:text-sm'>{catLogs.length}</p>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="grid grid-cols-4 gap-y-1 text-sm text-gray-700">
                                    {Object.entries(typeCounts).map(([type, count]) => (
                                            <React.Fragment key={type}>
                                            <div className="col-span-3">
                                                <span
                                                className={`text-[10px] xl:text-[11px] px-1 xl:px-2 py-[1px] capitalize rounded-full inline-block ${getBadgeClass(`${type.toLowerCase()}!`)}`}
                                                >
                                                {type}
                                                </span>
                                            </div>
                                            <div className="col-span-1 mx-1 px-1">
                                                <div className="flex justify-center items-center w-6 h-6 rounded-full bg-gray-100 border border-gray-300">
                                                <p className="text-xs font-semibold">{count}</p>
                                                </div>
                                            </div>
                                            </React.Fragment>
                                        ))}
                                </div>

                            </div>
                            <div className='col-span-2 flex flex-col justify-center items-center'>
                                <div>
                                    <p className='text-sm xl:text-lg font-bold text-gray-700 mb-2'>Points:</p>
                                </div>
                                <div className='flex justify-center items-center rounded-full w-8 h-8 xl:w-12 xl:h-12 bg-lime-500 shadow-lg shadow-black'>
                                    {/* <p className='text-[10px] font-bold'>{earnedPoints}</p> */}
                                    <p className='text-md font-bold'>{calculateExcellencePointsForCategory(catLogs)}</p>
                                </div>
                            </div>
                        </div>  
                    </div>
                );
                })}
            </div>
            )}

          </div>
        )}

    </div>
  );
};

const User = ({ username, defaultUserPic }) => {
    const { data: userPic, isFetching: isFetchingUserPic } =
      useGetUserPicQuery(username)
  
    return (
      <div className="flex justify-center items-center h-12 w-12 rounded-full border border-white bg-gradient-to-r from-orange-600 to-orange-400 shadow-lg shadow-black cursor-pointer">
        {/* Display user picture or loading indicator*/}
        {isFetchingUserPic ? (
          <div>Loading...</div>
        ) : userPic ? (
          <img src={userPic} alt="User" className="h-11 w-11  rounded-full" />
        ) : (
          <img src={defaultUserPic} alt="User" className="h-10 w-10 p-1" />
        )}
      </div>
    )
}

export default EtTrinityWebCelebrateExcellenceLog;